let caMoMeDr = false, caMaMeCl = false;
const appendRemoveEle = function(noscript_ele, aapend_ele, callBack = null){
  let obj_childs = new DOMParser().parseFromString(noscript_ele.innerHTML, 'text/html').querySelector('body').children;
  for (const [key, value] of Object.entries(obj_childs)) {            
    aapend_ele.append(value);
  }
  noscript_ele.remove();
  callBack != null && (callBack());
};

function callMainMenuClicks() {
  if( caMaMeCl ) return;
  document.querySelectorAll('.first-lavel > li > a:not(.anchor-link)').forEach((menu_link) => {
    menu_link.addEventListener('click',function(e){
      e.stopPropagation();
      e.preventDefault();
      const colest_li_ele = menu_link.closest('li');
      document.querySelector('.algolia-header-popup-show .autocomplete-close') && (
        document.querySelector('.algolia-header-popup-show .autocomplete-close').click()
      );

      if(colest_li_ele.classList.contains('mega-nav')){ onHover(); }
      if(colest_li_ele.getAttribute('id') != undefined && colest_li_ele.getAttribute('id') == 'brands'){ brandOnHover(); }
      
      if(colest_li_ele.classList.contains('mega-nav')){
        const noscript_ele = colest_li_ele.querySelector('noscript.contentString');
        if(noscript_ele){
          appendRemoveEle(noscript_ele, colest_li_ele, function(){
            onHover();
            callSublevelMenu();
          });          
        }
        if(colest_li_ele.querySelector('.mega-main-wrapper .child-level-one li').firstElementChild.classList.contains('open')){
          var get_first_height = colest_li_ele.querySelector('.child-level-two li.has-dropdown').firstElementChild.querySelector('.guide-and-promos').offsetHeight;
          const temp_ele = colest_li_ele.querySelector('.child-level-two li.has-dropdown').firstElementChild.querySelector('.child-level-three');          
          temp_ele.style.maxHeight = 'calc((100% - 48px) - '+get_first_height+'px)';
          //temp_ele.style.maxHeight = 'calc((100% - 48px)';
          //big-grid
        }
      }else{
        const noscript_ele = colest_li_ele.querySelector('noscript.contentString');
        if( noscript_ele ){          
          appendRemoveEle(noscript_ele, colest_li_ele, function(){
            brandOnHover();
          });
        }
      }

      if(this.closest('li').querySelectorAll('.comm-drop-menu').length > 0){
        if(this.closest('li').classList.contains('open')){
          this.closest('li').classList.remove('open');
        }else{
          document.querySelectorAll('.first-lavel > li.open').forEach((open_li) => {
            open_li.classList.remove('open');
          })
          this.closest('li').classList.add('open');          
        }
      }      
    })
  });  
  caMaMeCl = true;  
};

function callSublevelMenu(){
  document.querySelectorAll('.child-level-one li.sublevel-menu').forEach((mainmenu_sub_menu) => {
    mainmenu_sub_menu.addEventListener('click',function(event){
      event.stopPropagation();

      if(mainmenu_sub_menu.closest('.child-level-one').querySelector('.sublevel-menu.open')){
        mainmenu_sub_menu.closest('.child-level-one').querySelector('.sublevel-menu.open').classList.remove('open');
      }

      if(mainmenu_sub_menu.closest('.child-level-one').querySelector('.sublevel-menu.active')){
        mainmenu_sub_menu.closest('.child-level-one').querySelector('.sublevel-menu.active').classList.remove('active');
      }

      if(mainmenu_sub_menu.querySelector('.child-level-two')){
        mainmenu_sub_menu.querySelector('.child-level-two').classList.add('open');
        mainmenu_sub_menu.querySelector('.child-level-two').classList.add('active');
        mainmenu_sub_menu.querySelector('.child-level-three').classList.add('open');
      }

      if( mainmenu_sub_menu.querySelector('.child-level-three.open') 
        && mainmenu_sub_menu.querySelectorAll('.child-level-three.open ul li').length > 24){
        mainmenu_sub_menu.closest('.menu-wrapper').classList.add('with-child-big');
      }else{
        mainmenu_sub_menu.closest('.menu-wrapper').classList.remove('with-child-big');
      }
      
      // mainmenu_sub_menu.closest('li').querySelector('.child-level-two li.open').classList.remove('open');
      // mainmenu_sub_menu.closest('li').querySelector('.child-level-two li.has-dropdown').firstElementChild.classList.add('open');
      

      // if(mainmenu_sub_menu.closest('li').querySelector('.child-level-two li.has-dropdown').firstElementChild.querySelectorAll('.guide-and-promos').length > 0){
      //   var get_height = mainmenu_sub_menu.closest('li').querySelector('.child-level-two li.has-dropdown').firstElementChild.querySelector('.guide-and-promos').offsetHeight;
      //   mainmenu_sub_menu.closest('li').querySelector('.child-level-two li.has-dropdown').firstElementChild.querySelector('.child-level-three').style.maxHeight = 'calc((100% - 48px) - '+get_height+'px)';
      // }

      /*if(mainmenu_sub_menu.closest('li').querySelector('.child-level-two li.open') 
        && mainmenu_sub_menu.closest('li').querySelector('.child-level-two li.open').querySelectorAll('.child-level-three ul li').length > 24){
        mainmenu_sub_menu.closest('.menu-wrapper').classList.add('with-child-big');
      }else{
        mainmenu_sub_menu.closest('.menu-wrapper').classList.remove('with-child-big');
      }*/

      if(mainmenu_sub_menu.closest('li').classList.contains('has-dropdown')){
        mainmenu_sub_menu.closest('li').classList.add('open');
      }

      if(mainmenu_sub_menu.closest('li').querySelectorAll('.guide-wrapper a').length == 0 && 
          mainmenu_sub_menu.closest('li').querySelectorAll('.child-level-three').length == 0 && 
          mainmenu_sub_menu.closest('li').querySelectorAll('.promos-wrapper a').length == 0
      ){
        mainmenu_sub_menu.closest('.menu-wrapper').classList.add('no-third-child');	
      }else{
        mainmenu_sub_menu.closest('.menu-wrapper').classList.remove('no-third-child');
      }

      mainmenu_sub_menu.closest('li').classList.add('active');
    })
  });
  document.querySelector('li.has-dropdown.sublevel-menu.open').click();
}

function onHover(){
  document.querySelectorAll('.child-level-two li.inner-li').forEach((hover_second_menu)=>{
    hover_second_menu.addEventListener('mouseover', e => {
      e.stopPropagation();
      const parent_ele = hover_second_menu.closest('.sublevel-menu');       
      const hover_arr = hover_second_menu.getAttribute('data-hover-content');      
      const hover_ele = parent_ele.querySelector('.child-level-two--childs .child-level-three[data-hover="'+hover_arr+'"]');
      // var chk_height = hover_second_menu.querySelector('.guide-and-promos') && hover_second_menu.querySelector('.guide-and-promos').offsetHeight;
      // if(chk_height != undefined && chk_height != 0){
      //   hover_second_menu.querySelector('.child-level-three').style.maxHeight = 'calc((100% - 48px) - '+chk_height+'px)';
      // }
      parent_ele.querySelectorAll('li.open').forEach((ele) => {
        ele.classList.remove('open')        
      });
      parent_ele.querySelectorAll('.child-level-three.open').forEach((ele) => {
        ele.classList.remove('open')        
      });
        
      hover_second_menu.closest('.menu-wrapper').classList.add('no-third-child');
      if(hover_second_menu.classList.contains('has-dropdown')){
        hover_second_menu.classList.add('open');
        hover_second_menu.closest('.menu-wrapper').classList.remove('no-third-child');
        hover_ele.classList.add('open');
      }
      if(hover_ele){
        if(hover_ele.querySelectorAll('ul li').length > 12){
          hover_second_menu.closest('.menu-wrapper').classList.add('with-child-big');
        }else{
          hover_second_menu.closest('.menu-wrapper').classList.remove('with-child-big');
        }
      }
    })
  })
  return;
}

function brandOnHover(){
  document.querySelectorAll('.brand-mega-menu-sidebar ul li a').forEach((hover_brand) => {
    hover_brand.addEventListener('mouseover', e => {
      e.target.closest('ul').querySelector('li.active').classList.remove('active');
      e.target.parentNode.classList.add('active');
      var chk_handle = e.target.getAttribute('data-tab-title');
      document.querySelectorAll('.brand-mega-menu-content .inner_div_wrap.active').forEach((active_inner_brand) => {
        active_inner_brand.classList.remove('active');
      })
      document.querySelector('.brand-mega-menu-content .inner_div_wrap[data-tab-title="'+chk_handle+'"]').classList.add('active');
    })
  })
  return;
}

function callMobileMenuDrawer(){
  if( caMoMeDr ) return;
  document.querySelector('.header__mobile-nav-toggle').addEventListener('click',function(){
    document.querySelector('body.search-mobile-open .mobile-search-close') && (
      document.querySelector('body.search-mobile-open .mobile-search-close').click()
    );

    if(document.querySelector('html').classList.contains('overflow-hide')){
      document.querySelectorAll('.is-open').forEach((openClass)=>{
        openClass.classList.remove('is-open');
      })
      document.querySelector('sticky-header').classList.toggle('sticky-header');
      document.querySelector('html').classList.toggle('overflow-hide');
      document.querySelector('.mobile-menu').style.maxHeight = 0;
      document.querySelector('.mobile-menu').setAttribute('aria-hidden','true');
    }else{
      document.querySelector('sticky-header').classList.toggle('sticky-header');
      document.querySelector('html').classList.toggle('overflow-hide');
      document.querySelector('.mobile-menu').style.maxHeight = "".concat(window.innerHeight - document.querySelector('sticky-header').getBoundingClientRect().bottom, "px");
      document.querySelector('.mobile-menu').setAttribute('aria-hidden','false');
    }      
  });
  callMobileMenuClicks();
  caMoMeDr = true;  
}

function callMobileMenuClicks(){
  document.querySelectorAll('.mobile-menu__inner .mobile-menu__panel ul li.mobile-menu__nav-item').forEach((mobile_menu_item)=>{
    if(mobile_menu_item.querySelectorAll('button').length > 0){
      mobile_menu_item.querySelectorAll('button').forEach((inner_btns) => {
        inner_btns.addEventListener('click',function(e){
          const active_ele = document.querySelector('#'+this.getAttribute('aria-controls'));
          const noscript_ele = active_ele.querySelector('noscript.contentString');
          document.querySelector('#'+this.getAttribute('aria-controls')).classList.add('is-open');
          if( noscript_ele ){
            appendRemoveEle(noscript_ele, active_ele, function(){ 
              active_ele.querySelectorAll('button').forEach((act_btns) => {
                act_btns.addEventListener('click',function(e){
                  const act_ele = document.querySelector('#'+this.getAttribute('aria-controls'));
                  act_ele && act_ele.classList.add('is-open');
                })
              });
              active_ele.querySelectorAll('.mobile-menu__panel>.mobile-menu__section .mobile-menu__back-button').forEach((submenu_close_btn)=>{
                submenu_close_btn.addEventListener('click',(e)=>{
                  submenu_close_btn.closest('.mobile-menu__panel').classList.remove('is-open');
                })
              })
            });
          }
        })
      })
    } 
  })

  document.querySelectorAll('.mobile-menu__panel>.mobile-menu__section .mobile-menu__back-button').forEach((submenu_close_btn)=>{
    submenu_close_btn.addEventListener('click',(e)=>{
      submenu_close_btn.closest('.mobile-menu__panel').classList.remove('is-open');
    })
  })
}

/* mobilemenu JS */
if(window.innerWidth < 1000 ){    
  callMobileMenuDrawer();
  // callMobileMenuClicks();
}else{        
  callMainMenuClicks();  
}
/* mobilemenu JS End */

function handleResize() {  
  if(window.innerWidth < 1000 && caMoMeDr == false ){        
    //caMoMeDr = true;
    callMobileMenuDrawer();
  } else if( window.innerWidth > 999 && caMaMeCl == false ) {        
    //caMaMeCl = true;    
    callMainMenuClicks()
  }
}
const debouncedHandleResize = debounce(handleResize, 500);
window.addEventListener('resize', debouncedHandleResize);


document.addEventListener("DOMContentLoaded", (event) => {

  

  /* Load script agin if it's became undefined */
  setTimeout(function(){
    //checkSlickScript();
  });  
  /* Load script agin if it's became undefined */

  /* show more/less */  
    function toggleVisibility(element, parentSelector, hideSelector, showSelector) {
      const parent = element.closest(parentSelector);
      parent.querySelector(hideSelector).classList.add('hidden');
      parent.querySelector(showSelector).classList.remove('hidden');
    }
    
    function adjustHeight(element, viewportSelector) {
      const parent = element.closest(viewportSelector);
      const height = parent.offsetHeight;
      parent && (parent.style.height = height + 'px');
    }
    
    document.querySelectorAll('.see_more').forEach(function(element) {
      element.addEventListener('click', function() {
        toggleVisibility(this, '.applicable_text', '.More_description', '.Less_description');
        adjustHeight(this, '.flickity-viewport');
      });
    });
    
    document.querySelectorAll('.see_less').forEach(function(element) {
      element.addEventListener('click', function() {
        toggleVisibility(this, '.applicable_text', '.Less_description', '.More_description');
        adjustHeight(this, '.flickity-viewport');
      });
    });
    
    document.querySelectorAll('.P_show').forEach(function(element) {
      element.addEventListener('click', function() {
        toggleVisibility(this, '.product_short_desc', '.More_description', '.Less_description');
      });
    });
    
    document.querySelectorAll('.P_less').forEach(function(element) {
      element.addEventListener('click', function() {
        toggleVisibility(this, '.product_short_desc', '.Less_description', '.More_description');
      });
    });
    
    document.querySelectorAll('.D_show').forEach(function(element) {
      element.addEventListener('click', function() {
        toggleVisibility(this, '.pro-content', '.More_description', '.Less_description');
      });
    });
    
    document.querySelectorAll('.D_less').forEach(function(element) {
      element.addEventListener('click', function() {
        toggleVisibility(this, '.pro-content', '.Less_description', '.More_description');
      });
    });
  /* show more/less */
  
  /*---------------home_slideshow flickity js---------------*/  
    // $('.slideshow').each(function(index,ele){
    //   var options = $(this).closest('.sec-slideshow').attr('data-section-settings');
    //   var $carousel;
    //   if(options != '' && options != undefined){
    //     $carousel = $(this).flickity(JSON.parse(options));
    //   }else{
    //     $carousel = $(this).flickity({
    //       "prevNextButtons": false,
    //       "pageDots": true,
    //       "wrapAround": true,
    //       "contain": true,
    //       "cellAlign": "left"
    //     });    
    //   }
    // });
       
    function setMaxHeightToViewport() {
      const container = document.querySelector('.home-slideshow .container');
      if (!container) return;
      if (window.innerWidth < 1200) return;
    
      const slideshow = container.querySelector('.sec-slideshow');
      const promo = container.querySelector('.hero-promo-banner');
    
      if (slideshow && promo) {
        const slideshowHeight = slideshow.offsetHeight;
        const promoHeight = promo.offsetHeight;
        const maxHeight = Math.max(slideshowHeight, promoHeight);
    
        const viewport = slideshow.querySelector('.flickity-viewport');
        if (viewport) {
          viewport.style.minHeight = `${maxHeight}px`;
        }
      }
    }
    setMaxHeightToViewport();    
    window.addEventListener('resize', debounce(setMaxHeightToViewport, 300));
  /*---------------home_slideshow flickity js---------------*/

  /* header menu JS */
  callMainMenuClicks();

  // if(document.querySelectorAll(".brand-mega-menu-sidebar ul li a").length > 0 ){
  //   brandOnHover();
  // }
  /* header menu JS END */

  

  /* collection filter JS */
  if(document.querySelectorAll('body.template-collection').length > 0 || document.querySelectorAll('body.template-search').length > 0){
    if(document.querySelector('.filters-short-bar')){
      document.querySelector('.filters-short-bar').classList.add('filters-short-bar-fixed');
    }
    
    document.addEventListener('scroll', function () {
      // if(document.querySelector('#chat-widget-container')){
      //   document.querySelector('#chat-widget-container').classList.add('hidden');
      // }
      /*const filtersShortBar = document.querySelector('.filters-short-bar');
      const algoliaProductList = document.querySelector('.algolia-product-list');

      if (!filtersShortBar || !algoliaProductList) return;

      const scrollPosition = window.scrollY;
      const filtersShortBarTop = filtersShortBar.offsetTop;
      const algoliaProductListHeight = algoliaProductList.offsetHeight;

      if (scrollPosition > filtersShortBarTop) {
          filtersShortBar.classList.add('filters-short-bar-fixed');
      } else {
          filtersShortBar.classList.remove('filters-short-bar-fixed');
      }

      if (scrollPosition > algoliaProductListHeight) {
          filtersShortBar.classList.add('fixed-hidden');
      } else {
          filtersShortBar.classList.remove('fixed-hidden');
      }*/
    });
  }
  /* collection filter JS end */
  
});

// async function checkSlickScript(callback = '', magnificCallback = '', flickityCallback = ''){
//   if (!document.body.hasAttribute('data-check-script')) {
//     document.body.setAttribute('data-check-script-count', 0);
//   }  

//   let _count = Number(document.body.getAttribute('data-check-script-count'));

//   if (typeof window.jQuery !== 'undefined') {
//     var count = 0;
    
//     if( typeof jQuery.fn.slick === "undefined" ){
//       // Create a new script element for slick      
//       let slickScript = document.createElement('script');
//       let slickSrc = document.querySelector('[data-load-slick]').getAttribute('src');
//       let removeSlick = document.querySelector('script:not([data-load-slick])[src="'+slickSrc+'"]');
//       removeSlick && removeSlick.remove();
//       slickScript.src = slickSrc;      
//       slickScript.addEventListener("load", () => {
//         if( typeof callback == 'function' ){
//           callback();
//         }
//       });
//       document.head.appendChild(slickScript);
//       count += 1;
//     }else if( typeof jQuery.fn.slick != "undefined" && typeof callback == 'function' ){
//       count += 1;
//       callback();
//     }else{
//       count += 1;
//     }

//     if (typeof jQuery.fn.magnificPopup === "undefined") {      
//       // Create a new script element for magnificPopup
//       let magnificScript = document.createElement('script');
//       let magnificSrc = document.querySelector('[data-load-magnific]').getAttribute('src');
//       magnificScript.src = magnificSrc;
//       let removeMag = document.querySelector('script:not([data-load-magnific])[src="'+magnificSrc+'"]');
//       removeMag && removeMag.remove();

//       magnificScript.addEventListener("load", () => {        
//         if( typeof magnificCallback == 'function' ){
//           magnificCallback();
//         }
//         magnificPopupInstance();
//       });
//       document.head.appendChild(magnificScript);
//       count += 1;
//     }else if( typeof jQuery.fn.magnificPopup != "undefined" && typeof magnificCallback == 'function' ){
//       count += 1;
//       magnificCallback();      
//     }else{
//       count += 1;
//     }   


//     if (typeof jQuery.fn.flickity === "undefined") {      
//       // Create a new script element for magnificPopup
//       let flickityScript = document.createElement('script');
//       let flickitySrc = document.querySelector('[data-load-flickity]').getAttribute('src');
//       flickityScript.src = flickitySrc;
//       let removeMag = document.querySelector('script:not([data-load-flickity])[src="'+flickitySrc+'"]');
//       removeMag && removeMag.remove();

//       flickityScript.addEventListener("load", () => {        
//         if( typeof flickityCallback == 'function' ){
//           flickityCallback();
//         }
        
//       });
//       document.head.appendChild(flickityScript);
//       count += 1;
//     }else if( typeof jQuery.fn.flickity != "undefined" && typeof flickityCallback == 'function' ){
//       count += 1;
//       flickityCallback();      
//     }else{
//       count += 1;
//     }   

//     if( count == 3 ){
//       document.body.removeAttribute('data-check-script-count');
//     }else{
//       setTimeout(function () {
//         checkSlickScript();
//       }, 1000);
//     }    
//   } else {
//     if (_count < 11) {
//       _count++;
//       document.body.setAttribute('data-check-script-count', _count);

//       setTimeout(function () {
//         checkSlickScript();
//       }, 1000);
//     } else {
//       document.body.removeAttribute('data-check-script-count');
//     }
//   }
// }


// function magnificPopupInstance(){
//   if (typeof jQuery.magnificPopup === "undefined") {
//     setTimeout(function () {
//       checkSlickScript();
//     }, 1000);
//     return;
//   }
//   jQuery.magnificPopup.instance.close = function () {
//     magnificPopupClass(true);
//     $('.mfp-content .mfp-close').trigger('click');    
//     jQuery.magnificPopup.proto.close.call(this);    
//   };
//   jQuery.magnificPopup.instance.open = function(data) {
//     jQuery.magnificPopup.proto.open.call(this, data);
//     magnificPopupClass();
//   };
// }

// function magnificPopupClass(has_close = false){  
//   if( !has_close ){
//     $("body, html").addClass("price-match-popup-open");
//   }else{
//     if ($("body").hasClass("price-match-popup-open")) {
//       $('body, html').removeClass("price-match-popup-open");
//       $(".first-popup-custom").show();
//       $(".form-wrapper").hide();
//     }
//   }
// }

/* algolia mobile filter open JS */
function openPanel(t) {
  t.classList.contains("filters-drawer-btn") && (document.querySelector(".facets-left-filters").classList.add("active"), document.querySelector("html").classList.add("facets-drawer-open")), t.classList.contains("mobile-filters-close") && (document.querySelector(".facets-left-filters").classList.remove("active"), document.querySelector("html").classList.remove("facets-drawer-open"))
}

if(document.querySelector(".clr-button span[data-apply]") && document.querySelector(".clr-button span[data-apply]")){
  document.querySelector(".clr-button span[data-apply]").addEventListener("click", (function() {
    document.querySelector(".mobile-filters-close").click();
  }));
}

if(document.querySelector(".clr-button span[data-clear]") && document.querySelector(".clr-button span[data-clear]")){
  document.querySelector(".clr-button span[data-clear]").addEventListener("click", (function() {
    document.querySelector(".ais-ClearRefinements-button").click();
    document.querySelector(".mobile-filters-close").click();
  }));
}
/* algolia mobile filter open JS END */



/*************************Start Gift Balance Script*******************/
/* check-e-gift */
$(".check-bal-btn").click(function () {
  var GiftNumber = $(".gift-input-num").val();
  if (GiftNumber == "") {
    $(".error-gift-msg").show();
    $(".gift-value-out").hide();
    $(".gift-value-input").show();
  }
  else {


    $.ajax({
      url: "https://www.tagiftcards.com/api/giftcard_balance?giftcard_number=" + GiftNumber,
      crossDomain: true,
      type: "POST",
      success: function (html) {
        $(".error-gift-msg").hide();
        var GetPrice = (html['message']['balance']);
        GetPrice = "$" + GetPrice;
        var GetGiftId = (html['message']['giftcard_id']);
        $(".card-value").html(GetGiftId);
        $(".balance-value").html(GetPrice);
        $(".gift-value-out").show();
        $(".gift-value-input").hide();
        $(".gift-sec-title").html("YOUR e-GIFT CARD BALANCE");
        // console.log("suc");
      },
      error: function (error) {
        $(".error-gift-msg").show();
        $(".gift-value-out").hide();
        $(".gift-value-input").show();
      }
    });
  }
})
$(".revert-back").click(function () {
  $(".gift-value-out").hide();
  $(".gift-value-input").show();
  $(".card-value").html("");
  $(".balance-value").html("");
  $(".error-gift-msg").hide();
  $(".gift-input-num").val("");
  $(".gift-sec-title").html("CHECK e-GIFT CARD BALANCE");
})
/*************************End Gift Balance Script*******************/


document.addEventListener('click',function(e){
  if(e.target.closest('.search-container') == null & document.querySelector('.header_right .header_autocomplete').style.display === 'block'){
    let autocompleteContainer = window.innerWidth > 640 ? $("#header_autocomplete") : $("#header_autocomplete_mobile");
    $('.header_right .header-search,.popup-modal-mobile-search .header-search').val("");
    autocompleteContainer.html("");
    autocompleteContainer.hide();
    $('.autocomplete-close').hide();
  }
})

document.addEventListener('DOMContentLoaded', function () {
  const multicolumnSections = document.querySelectorAll('.swiper--multicolumn');

  multicolumnSections.forEach((section) => {
    new Swiper(section, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: false,
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
});

$(document).ready(function () {
   //faq page & returns-exchanges
  if ($(".template-faq").length || $(".template-page-help-center").length || $(".template-page.returns-exchanges").length) {
    // faq search
    $(document).on("keyup", "#sidebar-faq-search", function () {
      var q = $(this).val().toLowerCase();
      if (q.length >= 3) {
        $("[data-content]").addClass("hidden");
        $("[data-content*='" + q + "']").removeClass("hidden");

        $("[data-content*='" + q + "'].faq-qa-btn").closest("[data-faq-row]").addClass("active").find("[data-faq-title]").removeClass("hidden");
        $("[data-content*='" + q + "'].faq-qa-btn").closest("[data-faq-row]").find("[data-faq-qa-list]").slideDown();
        $("[data-content*='" + q + "'].faq-qa-btn").closest("[data-faq-question-wrap]").removeClass("hidden");

        $("[data-content*='" + q + "'].faq-title").closest("[data-faq-row]").find("[data-faq-qa-list] [data-faq-question-wrap]").removeClass("hidden");
        $("[data-content*='" + q + "'].faq-title").closest("[data-faq-row]").find("[data-faq-qa-list] [data-faq-question-wrap] [data-faq-question]").removeClass("hidden");

        $("[data-content*='" + q + "'].faq-qa-wrap").closest("[data-faq-row]").find("[data-faq-title]").removeClass("hidden");
        $("[data-content*='" + q + "'].faq-qa-wrap").closest("[data-faq-row]").addClass("active").find("[data-faq-qa-list]").slideDown();
        $("[data-content*='" + q + "'].faq-qa-wrap").find("[data-faq-question]").removeClass("hidden");
        $("[data-content*='" + q + "'].faq-qa-wrap").addClass("active").find("[data-faq-ans]").slideDown();

        // console.log("qa",$("[data-content*='" + q + "']"));
      } else {
        $("[data-content]").removeClass("hidden");
      }
    });

    // faq category show/hide
    $(document).on("click", "[data-faq-category]", function (e) {
      //remove hidden class and set blank search input
      e.preventDefault();
      var header = $("sticky-header").outerHeight(true) || 0;
      var id = $(this).attr("href");
      $("html, body").stop();
      $("html, body").animate({scrollTop: $(id).offset().top - header - 23},200);
      $("[data-content]").removeClass("hidden");
      $(".faq-content-wrapper #sidebar-faq-search").val("");
    });

    //faq questions/answer toggle
    $(document).on("click","[data-faq-question-wrap] [data-faq-question]",function () {
        $(this).closest(".faq-row").siblings().find("[data-faq-question-wrap]").removeClass("active").find("[data-faq-ans]").slideUp();
        $(this).closest("[data-faq-question-wrap]").siblings().removeClass("active").find("[data-faq-ans]").slideUp();
        $(this).closest("[data-faq-question-wrap]").toggleClass("active").find("[data-faq-ans]").slideToggle();
      }
    );

    // faq category title click
    $(document).on("click", "[data-faq-title]", function () {
      // $(this).closest("[data-faq-row]").siblings().removeClass("active").find("[data-faq-qa-list]").slideUp();
      $(this).closest("[data-faq-row]").toggleClass("active").find("[data-faq-qa-list]").slideToggle();
    });
  }
  // && faq page & returns-exchanges

  // Close navigation when clicking outside of it
  document.addEventListener("click", function(event) {
    if(event.target.closest('.main-navigation') == null && document.querySelectorAll('.mega-nav.open').length > 0){
      document.querySelectorAll('.mega-nav.open').forEach(function(megaNav){
        megaNav.classList.remove('open');
      });
    }
  });
});
